import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ajaxSupplierInvoicesPayments from "../../util/remote/ajaxSupplierInvoicesPayments";
const CreateSupplierPayments = () => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Form fields
  const [delID, setdelID] = useState("");
  const [invoice_no, setInvoiceNo] = useState("");
  const [amount, setAmount] = useState("");
  const [dateCreated, setDateCreated] = useState(() => {
    const today = new Date();
    return today.toLocaleDateString("en-CA"); // YYYY-MM-DD local
  });
  const [paymentMethod, setPaymentMethod] = useState("cash"); // default cash
  const [checkNumber, setCheckNumber] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  // Delivery notes (selectables)
  const [delivery_selectables, setdelivery_selectables] = useState([]);
  const fetchSupplierInvoicesSelectable = async () => {
    const server_response =
      await ajaxSupplierInvoicesPayments.fetchSupplierInvoicesSelectable({});
    if (server_response.status === "OK") {
      setdelivery_selectables(
        Array.isArray(server_response.details) ? server_response.details : []
      );
    } else {
      setdelivery_selectables([]);
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchSupplierInvoicesSelectable();
  }, []);
  // Validate required fields
  const allRowsFilled = () => {
    if (!delID || invoice_no.trim() === "" || amount.trim() === "")
      return false;
    if (paymentMethod === "check" && checkNumber.trim() === "") return false;
    if (paymentMethod === "bank transfer" && accountNumber.trim() === "")
      return false;
    return true;
  };
  // Submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please fill in all required fields");
      return;
    }
    const data = {
      InvoiceID: Number(delID),
      amount: amount,
      payment_method: paymentMethod,
      check_number: paymentMethod === "check" ? checkNumber : null,
      account_number: paymentMethod === "bank transfer" ? accountNumber : null,
      date_created: dateCreated,
      created_by: userId,
    };
    setLoading(true);
    const response = await ajaxSupplierInvoicesPayments.createSupplierPayment(
      data
    );
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setdelID("");
    setInvoiceNo("");
    setAmount("");
    setDateCreated(new Date().toISOString().split("T")[0]);
  };
  return (
    <AppContainer title="Create Supplier Payments">
      <div className="container-fluid">
        <Toaster />
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate("/supplier_payment/view")}
            >
              View Supplier Payments
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Create Supplier Payments</h6>
                <form onSubmit={handleAdd}>
                  <div className="row">
                    {/* Left column */}
                    <div className="col-md-6">
                      <div className="col-md-12 mb-3">
                        <label>
                          Select Supplier Invoice
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          onChange={(selected) => {
                            setdelID(selected?.id);
                            setInvoiceNo(selected?.invoice_no); // <-- set invoice number when user selects
                          }}
                          getOptionLabel={(option) => (
                            <span>
                              <span style={{ color: "red" }}>
                                Invoice number
                              </span>
                              ({option.invoice_no})
                              <span style={{ color: "green" }}> amount </span>(
                              {option.amount})
                              <span style={{ color: "red" }}> balance </span>(
                              {option.balance})
                            </span>
                          )}
                          getOptionValue={(option) => option.id}
                          isSearchable
                          options={
                            Array.isArray(delivery_selectables)
                              ? delivery_selectables
                              : []
                          }
                          value={
                            Array.isArray(delivery_selectables)
                              ? delivery_selectables.find(
                                  (value) => value.id === delID
                                ) || null
                              : null
                          }
                          placeholder="Select Supplier Invoice"
                        />
                      </div>
                      <div className="col-md-12 mb-3">
                        <label>
                          Invoice No <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          value={invoice_no}
                          onChange={(e) => setInvoiceNo(e.target.value)}
                          style={{ backgroundColor: "#fff", color: "#000" }} // make visible
                          className="form-control"
                          placeholder="Invoice Number"
                          required
                        />
                      </div>
                    </div>
                    {/* Right column */}
                    <div className="col-md-6">
                      <div className="form-group col-md-12 mb-3">
                        <label>
                          Amount <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-12 mb-3">
                        <label>
                          Date Created <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          value={dateCreated}
                          onChange={(e) => setDateCreated(e.target.value)}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      {/* Payment Method */}
                      <div className="form-group col-md-12 mb-3">
                        <label>
                          Payment Method <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          className="form-control"
                          value={paymentMethod}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          required
                        >
                          <option value="cash">Cash</option>
                          <option value="check">Check</option>
                          <option value="bank transfer">Bank Transfer</option>
                        </select>
                      </div>
                      {/* Conditional fields */}
                      {paymentMethod === "check" && (
                        <div className="col-md-12 mb-3">
                          <label>
                            Check Number <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter check number"
                            value={checkNumber}
                            onChange={(e) => setCheckNumber(e.target.value)}
                            required
                          />
                        </div>
                      )}
                      {paymentMethod === "bank transfer" && (
                        <div className="col-md-12 mb-3">
                          <label>
                            Account Number{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter account number"
                            value={accountNumber}
                            onChange={(e) => setAccountNumber(e.target.value)}
                            required
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-center col-lg-12">
                    <button
                      type="submit"
                      className="btn btn-success col-lg-12"
                      disabled={!allRowsFilled() || loading}
                    >
                      {loading ? <Loader /> : "Submit Supplier Invoice"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default CreateSupplierPayments;
